import { render, staticRenderFns } from "./VorstossDialog.vue?vue&type=template&id=0f197b30"
import script from "./VorstossDialog.vue?vue&type=script&lang=js"
export * from "./VorstossDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports